/**
 * Comma-separated allow list from NUXT_PUBLIC_QUERY_PARAM_ALLOW_LIST / runtimeConfig.public.paramsAllowList.
 * Keys are trimmed; only [a-zA-Z0-9_.-] (max 64 chars) are kept.
 * Prefer {@link parseParamsAllowListString} with **runtime** config in the Nuxt app — module-level
 * `NAVIGATION_PERSISTED_QUERY_KEYS` is often empty in the browser (workspace packages do not
 * always get Vite env inlining for import.meta / process).
 */
export function parseParamsAllowListString(raw: string | undefined | null): readonly string[] {
  if (raw == null || !String(raw).trim()) {
    return Object.freeze([]);
  }
  return Object.freeze(
    String(raw)
      .split(',')
      .map((k) => k.trim())
      .filter(
        (k) => /^[a-zA-Z0-9_.-]+$/.test(k) && k.length > 0 && k.length <= 64,
      ),
  );
}

/**
 * @deprecated For browser code use {@link parseParamsAllowListString} with
 * `useRuntimeConfig().public.paramsAllowList` instead. Only Node/build contexts resolve this reliably.
 */
function getNuxtPublicParamsAllowListFromEnv(): string {
  const meta = (import.meta as { env?: Record<string, string | undefined> }).env;
  if (meta?.NUXT_PUBLIC_QUERY_PARAM_ALLOW_LIST) {
    return meta.NUXT_PUBLIC_QUERY_PARAM_ALLOW_LIST;
  }
  if (typeof process !== 'undefined' && process.env?.NUXT_PUBLIC_QUERY_PARAM_ALLOW_LIST) {
    return process.env.NUXT_PUBLIC_QUERY_PARAM_ALLOW_LIST;
  }
  return '';
}

/** Legacy; prefer {@link parseParamsAllowListString} + runtime public config. */
export const NAVIGATION_PERSISTED_QUERY_KEYS: readonly string[] = parseParamsAllowListString(
  getNuxtPublicParamsAllowListFromEnv(),
);

export type NavigationPersistedQueryKey = string;
